// stores/useAutoRefreshStore.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";

export type RefreshFrequency = 10 | 20 | 30 | 40 | 50 | 60 | "off";

interface AutoRefreshState {
  frequency: RefreshFrequency;
  isLoading: boolean;
  lastManualRefresh: number | null;
  setFrequency: (freq: RefreshFrequency) => void;
  startLoading: () => void;
  stopLoading: () => void;
  setLastManualRefresh: (timestamp: number) => void;
}

export const useAutoRefreshStore = create<AutoRefreshState>()(
  persist(
    (set) => ({
      frequency: "off",
      isLoading: false,
      lastManualRefresh: null,
      setFrequency: (freq) => set({ frequency: freq }),
      startLoading: () => set({ isLoading: true }),
      stopLoading: () => set({ isLoading: false }),
      setLastManualRefresh: (timestamp) => set({ lastManualRefresh: timestamp }),
    }),
    {
      name: "auto-refresh-settings-2", // local storage key
    },
  ),
);
